<app-navsec></app-navsec>
<div class="container" style="margin-top: 3rem; margin-bottom: 3rem;">
    <div class="col-lg-12 text-center">
        <button class="btn btn-dark" [routerLink]="['/catalogo']" routerLinkActive="router-link-active">Regresar a productos</button>
    </div>
</div>